module.exports = __webpack_public_path__ + "fonts/F37GingerPro-Thin.ff7306b.woff2";